import Profile from "./layout/Profile";
import RecentProjects from "./layout/RecentProjects";
import TechnicalSkills from "./layout/TechnicalSkills";

function App() {
  return (
    <div className="App" id="#home">
      <Profile />
      <TechnicalSkills />
      <RecentProjects />
    </div>
  );
}

export default App;
